import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { FlutterInterface } from './flutterInterface';

export type RuntimeCommonConfig = {
    currency: string;
    currencyCode: string;
    porschePreowned: string;
    formats: {
        longDate: string;
        shortDate: string;
        time: string;
        datePickerFormat: string;
        timePickerFormat: string;
        dateTimePickerFormat: string;
        longDateTime: string;
        dateFormatForTemplate: string;
    };
};

export type RuntimeConfig = {
    version: string;
    publicPath: string;
    companyName: string;
    timeZone: string;
    countryCode: string;
    applicationName: string;
    branding: {
        logoUrl: string;
        faviconUrl: string;
    };
    common: RuntimeCommonConfig;

    locales: string[];
    defaultLocale: string;

    sentry: {
        dsn?: string;
        release?: string;
        environment?: string;
        tracing: boolean;
        tracesSampleRate: number;
    };

    flutterInterface: FlutterInterface;
};

export type RemoteRuntimeConfig = Omit<RuntimeConfig, 'flutterInterface'>;

export const RuntimeContext = createContext<RuntimeConfig>(null);

export const useRuntimeConfig = () => useContext(RuntimeContext);

export type RuntimeProviderProps = {
    runtime: RuntimeConfig;
    children: ReactElement | ReactNode;
};

export const RuntimeProvider = ({ runtime, children }: RuntimeProviderProps) => (
    <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>
);
